export enum HttpHeaderType {
    Auth = 'Auth',
    Normal = 'Normal'
}